export default __webpack_public_path__ + "media/svgs/tick-circle-green-0e2b8434.svg";